<template>
    <div class="vote">
        <div class="title">
            结果统计
        </div>
        <div class="vote_list">
            <van-list
                class="votte_list_box"
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="questionnaireResultList"
            >
                <van-cell class="vote_list_card" v-for="item in resultList" @click="goVoteResultDetail(item.questionnaire_id)" :key="item.questionnaire_id" center :title="item.title" :label="item.createTime" >
                    <template #right-icon>
                        <div class="search_icon_box">
                            <van-button plain type="primary" class="search_icon">结果</van-button>
                        </div>
                    </template>
                </van-cell>
            </van-list>
        </div>
    </div>
</template>

<script>
import { getQuestionnaireResultList } from '../../../api/api'
import { get } from '../../../utils/token'
export default {
  data () {
    return {
      list: [],
      loading: false,
      finished: false,
      value: '',
      resultList: [],

      page: 1,
      size: 10,
      mobile: get('mobile')
    }
  },
  mounted () {
    this.questionnaireResultList()
  },
  methods: {
    // 跳转问卷分析详情页
    goVoteResultDetail (id) {
      this.$router.push({
        path: '/exerland/questionnaireResultDetail',
        query: {
          questionnaire_id: id
        }
      })
    },
    // 获取问卷详情列表
    async questionnaireResultList () {
      try {
        this.loading = true
        const { page, size, mobile } = this
        const data = await getQuestionnaireResultList(page, size, mobile, '', 1, 'open')
        if (data.code === 200) {
          this.resultList = this.resultList.concat(data.data.list)
          this.loading = false
          if (this.resultList.length >= data.data.count) {
            this.finished = true
          } else {
            this.page++
          }
        }
      } catch (error) {
        /* eslint-disable-next-line */
        console.log(error)
      }
    }
  }
}
</script>

<style lang='scss' scoped>
.vote{
    width: 100%;
    height: 100%;
    // 此处不是最好的样式处理方案
    background-color: #f2f8fc;
    .title{
      width: 91.47%;
      height: 30px;
      line-height: 30px;
      margin: 0 auto;
      padding-top: 20px;
      font-size: 20px;
      font-weight: 600;
    }
    .vote_list{
        width: 100%;
        height: 100%;
        overflow-y: scroll;
        background-color: #f2f8fc;
        margin: 0;
        padding: 20px 0;
        .vote_list_card:nth-child(1){
            margin-top: 0;
        }
        .vote_list_card{
            margin: 20px auto;
            width: 91.47%;
            height: 70px;
            border-radius: 14px;
            .search_icon_box{
                line-height: inherit;
                .search_icon{
                  font-size: 13px;
                  width: 60px;
                  height: 30px;
                  border: 2px solid #e5e7e9;
                  border-radius: 8px;
                }
            }
        }
    }
}
</style>
